import { FormEvent, useMemo, useState } from 'react'
import { api } from './api'

function defaultDeviceName(): string {
  const mobile = /Android/i.test(navigator.userAgent)
  if (mobile) return 'Android 手机'
  if (/Windows/i.test(navigator.userAgent)) return 'Windows 电脑'
  return '我的设备'
}

export function PairingScreen({ onPaired }: { onPaired: () => void }) {
  const initialName = useMemo(defaultDeviceName, [])
  const [code, setCode] = useState('')
  const [deviceName, setDeviceName] = useState(initialName)
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setError('')
    setSubmitting(true)
    try {
      await api('/api/pairings/redeem', {
        method: 'POST',
        body: JSON.stringify({ code, deviceName }),
      })
      onPaired()
    } catch {
      setError('配对码无效或已经过期。请在受信设备或服务器上生成新配对码。')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="pairing-page">
      <section className="pairing-card" aria-labelledby="pairing-title">
        <img src="/focusnote-icon.svg" className="pairing-logo" alt="" />
        <h1 id="pairing-title">连接这台设备</h1>
        <p>输入一次性配对码。成功后，这台设备会直接打开你的笔记。</p>
        <form onSubmit={submit}>
          <label>
            配对码
            <input
              autoFocus
              autoCapitalize="characters"
              autoComplete="one-time-code"
              inputMode="text"
              placeholder="ABCD-EFGH"
              value={code}
              onChange={(event) => setCode(event.target.value.toUpperCase())}
              maxLength={9}
              required
            />
          </label>
          <label>
            设备名称
            <input
              value={deviceName}
              onChange={(event) => setDeviceName(event.target.value)}
              maxLength={80}
              required
            />
          </label>
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="primary-button" disabled={submitting}>
            {submitting ? '正在连接…' : '连接并打开笔记'}
          </button>
        </form>
      </section>
    </main>
  )
}
